import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b98027bc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container mg-b--15"
};
const _hoisted_3 = {
  class: "table__container",
  ref: "tableContainer"
};
const _hoisted_4 = {
  class: "header"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_6 = {
  class: "table-list",
  ref: "tableWarpRef"
};
import { nextTick, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { objToArr } from '@/utils/tools';
import TagType from '@/views/common/TagType/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import AddTestDevice from './addTestDevice.vue';
import TestReport from './testReport.vue';
import { messageBox } from '@/utils/validate';
import { getTestMissionListApi, getTestDeviceApi, startTestApi, stopTestApi, deleteTestApi, startAutoTestApi } from '@/api/live';
import dayjs from 'dayjs';
import { getCurrentTime } from '@/utils/timeFormat';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const isShowAside = ref(true);
    const tableRef = ref();
    const activeTag = ref(0); //激活的选项卡

    const testMissionData = ref(); //测试任务表单数据

    const testDeviceData = ref([]); //测试设备表单数据

    const testOptions = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('任务未开始'),
      value: -1
    }, {
      label: t('正常停止'),
      value: 0
    }, {
      label: t('手动开始'),
      value: 1
    }, {
      label: t('自动任务正常停止'),
      value: 2
    }, {
      label: t('手动停止'),
      value: 3
    }, {
      label: t('异常停止'),
      value: 4
    }, {
      label: t('完成'),
      value: 5
    }]);
    const testDeviceOptions = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('账号空闲中'),
      value: 0
    }, {
      label: t('账号正在测试'),
      value: 1
    }]);
    const addTestDeviceObj = ref({
      visible: false,
      mode: 'add',
      data: {}
    });
    const testReportObj = ref({
      visible: false,
      mode: 'add',
      data: {}
    });
    const REVIEW_STATUS = {
      '0': '测试任务',
      '1': '测试设备'
    };
    onMounted(() => {
      getTestMissionList(1, 10);
    }); // 计算sn/账号的文字颜色

    const calculateColor = row => {
      let color = '';

      if (row.state == 0) {
        //状态异常
        color = 'red';
      }

      return color;
    };

    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name');
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    }); // 处理点击事件

    const handleTagClick = tag => {
      console.log('tag', tag);
      activeTag.value = tag.type;
    };

    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: 'SN/账号',
        prop: 'sn',
        widgetType: 'input'
      }, {
        label: '测试时间',
        prop: 'time',
        widgetType: 'date',
        type: 'daterange',
        clearable: false,
        formatter: value => getCurrentTime(value)
      }, {
        label: '测试状态',
        prop: 'stopState',
        widgetType: 'Select',
        list: testOptions,
        valueKey: 'value'
      }],
      formData: {
        stopState: '',
        time: [dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sn: '',
        state: ''
      }
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: '添加测试设备',
        controller: () => {
          if (activeTag.value == 1) return true;
        },
        type: 'green',
        func: () => {
          console.log('添加测试设备');
          addTestDeviceObj.value.visible = true;
          addTestDeviceObj.value.mode = 'add';
          addTestDeviceObj.value.data = {};
        }
      }, // {
      //   label: '测试参数设置',
      //   type: 'primary',
      //   func: () => {
      //     console.log('测试参数设置')
      //   }
      // },
      {
        label: '',
        func: () => {},
        cellSlot: true
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '序号',
        prop: 'no',
        align: 'left',
        width: 100
      }, {
        label: 'SN/账号',
        prop: 'sn',
        align: 'left',
        width: 250,
        cellSlot: true,
        slotName: 'snColumn'
      }, {
        label: '测试节目总数',
        prop: 'channelCount',
        align: 'left',
        width: 150
      }, {
        label: '正常节目数量',
        prop: 'successCount',
        align: 'left',
        width: 150
      }, {
        label: '异常节目数量',
        prop: 'failCount',
        align: 'left',
        width: 150
      }, {
        label: '测试状态',
        prop: 'stopState',
        align: 'left',
        width: 150,
        formatter: value => {
          if (value === undefined) return '/';
          let target = testOptions.value.filter(item => item.value == value);
          let label = target.length === 0 ? undefined : target[0].label;
          return label;
        }
      }, {
        label: '测试时长',
        prop: 'runTime',
        align: 'left',
        width: 150
      }, {
        label: '开始测试时间',
        prop: 'beginTime',
        align: 'left',
        width: 220,
        formatter: value => {
          return value === null ? '/' : value;
        }
      }, {
        label: '操作',
        prop: '',
        align: 'left',
        widgetType: 'buttons',
        fixed: 'right',
        buttonsList: [{
          label: '测试报告',
          func: data => {
            console.log('visible', testReportObj.value.visible);
            testReportObj.value.visible = true;
            testReportObj.value.data = data;
          }
        }]
      }]
    }); // 监听activeTag的变化，变更表单数据

    watch(() => activeTag.value, newVal => {
      switch (Number(newVal)) {
        case 0:
          searchConfig.formList = [{
            label: 'SN/账号',
            prop: 'sn',
            widgetType: 'input'
          }, {
            label: '测试时间',
            prop: 'time',
            widgetType: 'date',
            type: 'daterange',
            formatter: value => getCurrentTime(value)
          }, {
            label: '测试状态',
            prop: 'stopState',
            widgetType: 'Select',
            list: testOptions,
            valueKey: 'value'
          }];
          searchConfig.formData.stopState = '';
          searchConfig.formData.time = [dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')];
          getTestMissionList(1, 10);
          tableConfig.data = testMissionData.value;
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: 'SN/账号',
            prop: 'sn',
            align: 'left',
            width: 250
          }, {
            label: '测试节目总数',
            prop: 'channelCount',
            align: 'left',
            width: 150
          }, {
            label: '正常节目数量',
            prop: 'successCount',
            align: 'left',
            width: 150
          }, {
            label: '异常节目数量',
            prop: 'failCount',
            align: 'left',
            width: 150
          }, {
            label: '测试状态',
            prop: 'stopState',
            align: 'left',
            width: 150,
            formatter: value => {
              if (value === undefined) return '/';
              let label = testOptions.value.filter(item => item.value == value)[0].label;
              return label ? label : '/';
            }
          }, {
            label: '测试时长',
            prop: 'runTime',
            align: 'left',
            width: 150
          }, {
            label: '开始测试时间',
            prop: 'beginTime',
            align: 'left',
            width: 220
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            widgetType: 'buttons',
            fixed: 'right',
            buttonsList: [{
              label: '测试报告',
              func: data => {
                testReportObj.value.visible = true;
                testReportObj.value.data = data;
              }
            }]
          }];
          break;

        case 1:
          tableConfig.data = testDeviceData.value;
          searchConfig.formList = [{
            label: 'SN/账号',
            prop: 'sn',
            widgetType: 'input'
          }, {
            label: '账号状态',
            prop: 'state',
            widgetType: 'Select',
            list: testDeviceOptions,
            valueKey: 'value'
          }];
          searchConfig.formData.state = '';
          getTestDevice(1, 10);
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: '账号类型',
            prop: 'snType',
            align: 'left',
            width: 150,
            formatter: value => {
              if (value === undefined) return '/';
              return value === 0 ? 'SN' : 'Account';
            }
          }, {
            label: '账号',
            prop: 'sn',
            align: 'left',
            width: 300
          }, {
            label: '账号状态',
            prop: 'state',
            align: 'left',
            width: 150,
            formatter: value => {
              if (value === undefined) return '/';
              return value === 0 ? t('账号空闲中') : value === 1 ? t('账号正在测试') : t('测试等待中');
            }
          }, {
            label: '测试时间',
            prop: 'checkPoint',
            align: 'left',
            width: 500
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            widgetType: 'buttons',
            fixed: 'right',
            buttonsList: [{
              label: '手动开始测试',
              controller: data => {
                if (data.state == 0) return true;
              },
              func: val => {
                console.log('手动开始测试', val);
                messageBox(`${t('确定开始测试当前设备')}?`).then(async () => {
                  const {
                    code,
                    data
                  } = await startTestApi(val.sn);

                  if (code == 0) {
                    ElMessage({
                      type: 'success',
                      message: t('开始测试')
                    });
                    getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
                  }
                });
              }
            }, {
              label: '停用',
              controller: data => {
                if (data.state == 1 || data.state == 2) return true;
              },
              func: val => {
                console.log('停用', val);
                messageBox(`${t('确定停用当前设备')}?`).then(async () => {
                  const {
                    code,
                    data
                  } = await stopTestApi(val.sn);

                  if (code == 0) {
                    ElMessage({
                      type: 'success',
                      message: t('停用成功')
                    });
                    getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
                  }
                });
              }
            }, {
              label: '启用',
              controller: data => {
                if (data.state == 0) return true;
              },
              func: val => {
                messageBox(`${t('确定启用当前设备')}?`).then(async () => {
                  const {
                    code,
                    data
                  } = await startAutoTestApi(val.sn, val.snType);

                  if (code == 0) {
                    ElMessage({
                      type: 'success',
                      message: t('启用成功')
                    });
                    getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
                  }
                });
              }
            }, {
              label: '修改',
              controller: data => {
                if (data.state == 0) return true;
              },
              func: val => {
                addTestDeviceObj.value.visible = true;
                addTestDeviceObj.value.mode = 'edit';
                let cloneData = JSON.parse(JSON.stringify(val));
                cloneData.hours = cloneData.checkPoint.split(',');
                addTestDeviceObj.value.data = cloneData;
              }
            }, {
              label: '删除',
              controller: data => {
                if (data.state == 0) return true;
              },
              func: val => {
                console.log('删除', val);
                messageBox(`${t('确定删除当前设备')}?`).then(async () => {
                  const {
                    code,
                    data
                  } = await deleteTestApi(val.sn);

                  if (code == 0) {
                    ElMessage({
                      type: 'success',
                      message: t('删除成功')
                    });
                    getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
                  }
                });
              }
            }]
          }];
          break;
      }
    }); //添加测试设备完成的回调

    const updateTestDevice = () => {
      getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
    }; // 获取测试任务列表


    const getTestMissionList = async (pageNo, pageSize) => {
      try {
        loading.value = true;
        let params = {
          stopState: searchConfig.formData.stopState === '' ? undefined : searchConfig.formData.stopState,
          beginTime: searchConfig.formData.time[0],
          endTime: searchConfig.formData.time[1],
          sn: searchConfig.formData.sn.trim() === '' ? undefined : searchConfig.formData.sn
        };
        const {
          code,
          data
        } = await getTestMissionListApi(pageNo, pageSize, params);

        if (code == 0) {
          data.records.forEach((item, index) => {
            item.no = (pageNo - 1) * pageSize + index + 1; // 序号
          });
          tableConfig.data = data.records;
          tableConfig.paginationConfig.limit = data.size;
          tableConfig.paginationConfig.page = data.current;
          tableConfig.paginationConfig.total = data.total;
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    }; //点击查询


    const handleSearch = val => {
      console.log('act', activeTag.value);

      if (activeTag.value == 0) {
        //获取测试任务
        getTestMissionList(1, 10);
      }

      if (activeTag.value == 1) {
        //获取测试设备
        getTestDevice(1, 10);
      }
    }; // 重置


    const handleReset = () => {
      searchConfig.formData = {
        stopState: '',
        time: [dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sn: '',
        state: ''
      };
      tableConfig.data = [];
      tableConfig.paginationConfig = {
        page: 1,
        limit: 10,
        total: 0
      };
      handleSearch();
    };

    const sizeChange = val => {
      tableConfig.paginationConfig.limit = val;

      if (activeTag.value == 0) {
        //测试任务
        getTestMissionList(1, tableConfig.paginationConfig.limit);
      }

      if (activeTag.value == 1) {
        //获取测试设备
        getTestDevice(1, tableConfig.paginationConfig.limit);
      }
    };

    const currentChange = val => {
      tableConfig.paginationConfig.page = val;

      if (activeTag.value == 0) {
        //测试任务
        getTestMissionList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
      }

      if (activeTag.value == 1) {
        //获取测试设备
        getTestDevice(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit);
      }
    }; // 获取测试设备


    const getTestDevice = async (pageNo, pageSize) => {
      try {
        loading.value = true;
        let params = {
          sn: searchConfig.formData.sn.trim() === '' ? undefined : searchConfig.formData.sn,
          state: searchConfig.formData.state === '' ? undefined : searchConfig.formData.state
        };
        const {
          code,
          data
        } = await getTestDeviceApi(pageNo, pageSize, params);

        if (code == 0) {
          data.records.forEach((item, index) => {
            item.no = (pageNo - 1) * pageSize + index + 1; // 序号
          });
          tableConfig.data = data.records;
          tableConfig.paginationConfig.limit = data.size;
          tableConfig.paginationConfig.page = data.current;
          tableConfig.paginationConfig.total = data.total;
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref: "tagRef"
      }, null, 8, ["modelValue"]), _createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 30
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [_createVNode(_component_TableColumnOptionBtn, {
          "column-list": _unref(columnConfig).columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: _ctx.handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": _unref(columnConfig).columnList
        }, {
          snColumn: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              'color': calculateColor(scope.row)
            })
          }, _toDisplayString(scope.row.sn ? scope.row.sn : '--'), 5)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSelectionChange"])], 512)], 512)])])), [[_directive_loading, loading.value]]), _createVNode(AddTestDevice, {
        modelValue: addTestDeviceObj.value.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addTestDeviceObj.value.visible = $event),
        data: addTestDeviceObj.value.data,
        mode: addTestDeviceObj.value.mode,
        onUpdateList: updateTestDevice
      }, null, 8, ["modelValue", "data", "mode"]), _createVNode(TestReport, {
        modelValue: testReportObj.value.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => testReportObj.value.visible = $event),
        data: testReportObj.value.data,
        mode: testReportObj.value.mode
      }, null, 8, ["modelValue", "data", "mode"])], 64);
    };
  }

});